export function loadVendorJs() {
  const context = require.context(
    '../../vendor/',
    true,
    /\/resources\/assets\/js\/index\.js$/,
    'sync'
  );

  context.keys().forEach(context);

  // [Debug] 列出 load 的檔案路徑
  // context.keys().forEach((r) => console.log(r));
}
